/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import AuthApi from "../../../context/AuthApi";
import useDocumentTitle from "../../../utils/useDocumentTitle";

import styles from "./SessionsOverview.module.scss";
import SortableTable from "./SortableTable";

import PageContent from "../../../components/PageContent";
import Section from "../../../components/Section";
import SectionTitle from "../../../components/SectionTitle";
import { Tab, Tabs } from "../../../components/Tabs";
import { DashboardLayout } from "../../../layouts/DashboardLayout";

import { Metric, MetricsWrapper } from "../../../components/Metric";

import { useTranslation } from "react-i18next";
import ReminderPopUp from "../../../components/ReminderPopUp/index";
import { TableConfig } from "../../../config/Config";
import { IsCoach } from "../../../config/Roles";
import { useNotification } from "../../../context/notification";
import { apiRequest } from "../../../utils/api";
import { getLocalValue } from "../../../utils/auth";

export function SessionsPersonalOverview(props) {
  useDocumentTitle(props.title);
  const { t } = useTranslation();
  const Auth = useContext(AuthApi);
  const [perPage, setPerPage] = useState(TableConfig.resultPerPage);
  const [sessionPendingList, setSessionPendingList] = useState(0);
  const tableHeader = [
    {
      name: "session_ongoing_upcoming_date",
      label: t("sessionList.upcomingSession"),
      width: "11%",
    },
    {
      name: "session_datetime",
      label: t("sessionList.sessionDateTime"),
      width: "11%",
    },
    { name: "session_id", label: "Session ID", width: "8%" },
    { name: "", label: t("sessionList.time"), width: "8%" },
    {
      name: "session_ongoing_upcoming_type",
      label: t("sessionList.type"),
      width: "10%",
    },
    { name: "subject", label: t("sessionList.subjects"), width: "14%" },
    { name: "coachee_fullname", label: t("sessionList.name"), width: "10%" },
    {
      name: "coachee_employee_id",
      label: t("sessionList.employeeID"),
      width: "9%",
    },
    { name: "status", label: t("sessionList.status"), width: "9%" },
  ];

  const { addNotification } = useNotification();
  const [personalData, setPersonalData] = useState(null);
  const [uid] = useState(getLocalValue("uid"));

  //ascending
  //descending

  useEffect(() => {
    // fetch from getSessionDetails api
    async function fetchData() {
      const response = await apiRequest.get(
        `/api/getOngoingPersonalSession?uid=${uid}`
      );

      if (response.status === 200) {
        const data = response.data.data;
        setPersonalData(data);
      } else {
        addNotification(
          t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
          "error"
        );
      }
    }
    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <SectionTitle>{t("sessionList.title")}</SectionTitle>
            {Auth.isCoach && (
              <Tabs>
                <Tab
                  label={t("tabs.team")}
                  tabName={t("tabs.team")}
                  linkTo={`/sessions/teams`}
                />
                <Tab
                  label={"personal"}
                  tabName={t("tabs.personal")}
                  defaultTab={true}
                />
              </Tabs>
            )}
            {IsCoach() && <ReminderPopUp />}
            <MetricsWrapper>
              <Metric
                label={t("sessionList.totalSessionPending")}
                data={sessionPendingList}
              />
            </MetricsWrapper>

            {personalData && (
              <SortableTable
                tableData={personalData}
                tableHeader={tableHeader}
                isPersonal={true}
                accessToCreateSession={false}
                perPage={perPage}
                setPerPage={setPerPage}
                subjectParam={`uid=${uid}`}
                onUpdatingFilter={count => {
                  setSessionPendingList(count);
                }}
              />
            )}
          </Section>
        </PageContent>
      </div>
    </DashboardLayout>
  );
}
